import { useContext, useState } from "react";
import { textes } from "../../constants/textes";
import { useParams } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import HotspotInfos from "../../components/hotspots/hotspotinfos";
import Waccounts from "../../components/hotspots/waccounts";



export default function ViewHotspots() {
    // states
    let codehotspot = useParams();
    const [page, setPage] = useState(0);
    const { user } = useContext(UserContext);

    const displayPages = () => {
        if (page === 0) {
            return <HotspotInfos codehotspot={codehotspot.code} />;
        }else {
            return <Waccounts codehotspot={codehotspot.code} />;
        }
    }

    // affichages
    return (
        <div className="container-fluid">
        <h1 className="h4 mb-4 font-weight-bold text_primary"><i className="fa fa-building mr-1"></i> {textes.fr.hotspotslabel}</h1>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", justifyItems: "center" }}>
                <button onClick={() => { setPage(0) }} className={`btn-shadow rounded-0 btn ${page === 0 ? 'btn-primary' : 'btn-secondary'}`}>
                    <span>{textes.fr.hotspotinfoslabel}</span>
                </button>
                <button onClick={() => { setPage(1) }} className={`btn-shadow rounded-0 btn ${page === 1 ? 'btn-primary' : 'btn-secondary'}`}>
                    <span>{textes.fr.wifiaccountslabel}</span>
                </button>
            </div>
            {displayPages()}
        </div>
    )

}